import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import Pagination from "./Pagination/Pagination";
import copy from "copy-to-clipboard";
import api, { uploadImage, requestData, apiUrl } from "../services/requests";
import CriarCarteira from "./criarCarteira";
import Carteira from "./painel/Carteira";
import VendedorCarteira from "./painel/VendedorCarteira";
import Drawer from "./Drawer"; // Import the new Drawer component
import VendedoresContent from "./VendedoresContent"; // Import the renamed component
import { toast } from "react-toastify";
const { criarCarteiras } = require("../services/requests");

const Painel = ({
  isSingleColumn,
  carteiras,
  setCarteiras,
  isAdmin,
  getCarteiras,
  filtragem,
  activeTab,
  setActiveTab,
  pagination = {},
  currentFilters,
}) => {
  const { page, limit, setPage, totalCount } = pagination;
  const date = new Date();
  const url = `https://www.uniscestudantil.org.br/carteiras/`;
  const newDate = moment(date).locale("pt-br").format("YYYY-MM-DD HH:mm:ss");
  const [openAcordeon, setOpenAcordeon] = useState(null);
  const [save, setSave] = useState(false);
  const [imagens, setImagens] = useState("");
  const [gestores, setGestores] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const setImagem = (id, file) => {
    setImagens((prevState) => ({
      ...prevState,
      [id]: file,
    }));
  };

  const getGestores = async () => {
    const endpoint = "/user/all";
    const gestores = await requestData(endpoint);
    setGestores(gestores);
  };

  const newArrayGestores = gestores.sort((a, b) =>
    a.name < b.name ? -1 : a.name > b.name ? 1 : 0
  );

  const toggleSave = (id) => {
    setSave((prevId) => (prevId === id ? null : id));
  };

  const toggleListVisibility = (id) => {
    setOpenAcordeon((prevId) => (prevId === id ? null : id));
  };

  const handleImageUpload = async (carteiraId, file) => {
    try {
      if (file) {
        const upload = "/upload-image";
        const formData = new FormData();
        formData.append("image", file);

        await uploadImage(upload, formData);

        await api.patch(`/carteiras/editar/${carteiraId}`, {
          foto: `${apiUrl}/images/${file.name}`,
        });

        toast.success("Imagem atualizada com sucesso!");
        getCarteiras(activeTab, currentFilters, page, limit);
      }
    } catch (error) {
      toast.error("Erro ao fazer upload da imagem.");
    }
  };

  const handleInputChange = async (e, id) => {
    const { name, value } = e.target;

    if (name === "status") {
      await api.patch(`/carteiras/editar/status/${id}`, {
        status: value,
      });
    }

    if (name === "observacao") {
      await api.patch(`/carteiras/observacao/${id}`, {
        observacao: value,
      });
    }

    setCarteiras((prevCarteiras) =>
      prevCarteiras.map((carteira) =>
        carteira.id === id ? { ...carteira, [name]: value } : carteira
      )
    );
  };

  const handleSave = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();

    const carteira = carteiras.find((carteira) => carteira.id === id);

    try {
      if (imagens[id] !== undefined) {
        const upload = "/upload-image";
        const formData = new FormData();
        formData.append("image", imagens[id]);
        await uploadImage(upload, formData);
      }
      const dadosParaEnvio = {
        ...carteira,
        nome: carteira.name,
        foto:
          imagens[id] === undefined
            ? carteira.foto
            : `${apiUrl}/images/${imagens[id].name}`,
      };

      await api.patch(`/carteiras/editar/${id}`, dadosParaEnvio);

      setCarteiras((prevCarteiras) =>
        prevCarteiras.map((carteira) =>
          carteira.id === id ? { ...carteira, ...dadosParaEnvio } : carteira
        )
      );

      setSave(null);

      getCarteiras(activeTab, currentFilters, page, limit);
      toast.success("Dados alterados com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar:", error);
      toast.error("Erro ao salvar os dados. Tente novamente.");
    }
  };

  const handleClick = async (carteira) => {
    try {
      setIsLoading(true);
      const endpoint = "/carteiras/renovacao";

      await criarCarteiras(endpoint, {
        foto: carteira.foto,
        codigoUso: carteira.codigoUso,
        nome: carteira.name,
        instituicaoEnsino: carteira.instituicaoEnsino,
        curso: carteira.curso,
        cpf: carteira.cpf,
        rg: carteira.rg,
        dataNascimento: carteira.dataNascimento,
        user_id: carteira.user_id,
        email: carteira.email,
        telefone: carteira.telefone,
      });

      await new Promise((resolve) => setTimeout(resolve, 5000));
      window.scrollTo(0, 0);
      getCarteiras(activeTab, currentFilters, page, limit);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      toast.success("Carteira renovada com sucesso!");
    }
  };

  function periodoDeRenovacao(carteira) {
    const dataHoje = newDate.split(" ")[0];
    const anoDataValidade = carteira.dataValidade.split("-")[0];
    const periodoRenovacao = new Date(anoDataValidade, 0, 1)
      .toISOString()
      .split("T")[0];
    const validadeCarteira = carteira.dataValidade.split("T")[0];
    return dataHoje >= periodoRenovacao && dataHoje <= validadeCarteira;
  }

  const copyToClipboard = (text) => {
    const url = `${window.location.origin}/carteiras/${text}`;
    copy(url);
  };

  const copyDados = (carteira) => {
    const texto = `
${carteira.name}
${carteira.instituicaoEnsino}
${carteira.curso}
CPF: ${carteira.cpf}
RG: ${carteira.rg}
Data Nasc: ${carteira.dataNascimento}`;
  copy(texto);
  };

  useEffect(() => {
    if (isAdmin) {
      getGestores();
    }
  }, [isAdmin]);

  const handleTagChange = async (carteiraId, newTag) => {
    try {
      setCarteiras((prevCarteiras) =>
        prevCarteiras.map((carteira) =>
          carteira.id === carteiraId ? { ...carteira, tag: newTag } : carteira
        )
      );

      await api.patch(`/carteiras/editar/${carteiraId}`, { tag: newTag });
      toast.success("Tag atualizada com sucesso!");
      getCarteiras(activeTab, currentFilters, page, limit);
    } catch (error) {
      toast.error("Erro ao atualizar a tag.");
      getCarteiras(activeTab, currentFilters, page, limit);
    }
  };

  return (
    <>
      <div className="relative border-gray-300">
        <div className="flex">
          <button
            className={`px-4 py-2 rounded-sm transition-all duration-300 ease-in-out transform hover:scale-105 ${
              activeTab === "gestores"
                ? "bg-blue-700 text-white shadow-lg"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
            onClick={() => setActiveTab("gestores")}
          >
            Carteiras
          </button>
          <button
            className={`px-4 py-2 ml-1 rounded-sm transition-all duration-300 ease-in-out transform hover:scale-105 ${
              activeTab === "vendedores"
                ? "bg-blue-700 text-white shadow-lg"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
            onClick={() => setActiveTab("vendedores")}
          >
            Colaboradores
          </button>
        </div>
      </div>

      <div
        className="relative bottom-0 top-1 mt-0 left-0 h-1 bg-blue-700 transition-all duration-300 ease-in-out"
        style={{
          width: activeTab === "gestores" ? "98px" : "120px",
          left: activeTab === "gestores" ? "0px" : "101px",
        }}
      ></div>

      <div className="overflow-hidden">
        {activeTab === "gestores" && (
          <div className="grid grid-cols-1 gap-5 border-t border-gray-300 p-2">
            <div
              className={`grid ${
                isSingleColumn ? "grid-cols-1" : "grid-cols-2"
              } 1500px:grid-cols-2 1100px:grid-cols-1`}
            >
              {page === 1 && !filtragem && (
                <CriarCarteira getCarteiras={getCarteiras} />
              )}
              {carteiras.map((carteira) => (
                <Carteira
                  key={carteira.codigoUso}
                  carteira={carteira}
                  openAcordeon={openAcordeon}
                  toggleListVisibility={toggleListVisibility}
                  imagens={imagens}
                  handleImageUpload={handleImageUpload}
                  setImagem={setImagem}
                  save={save}
                  handleInputChange={handleInputChange}
                  isLoading={isLoading}
                  periodoDeRenovacao={periodoDeRenovacao}
                  handleClick={handleClick}
                  copyDados={copyDados}
                  url={url}
                  copyToClipboard={copyToClipboard}
                  toggleSave={toggleSave}
                  handleSave={handleSave}
                  isAdmin={isAdmin}
                  newArrayGestores={newArrayGestores}
                />
              ))}
            </div>
            <div className="Resultados">
              {" "}
              {totalCount} Resultados encontrados{" "}
            </div>
            <Pagination
              className="pagination-bar"
              currentPage={page}
              totalCount={totalCount}
              pageSize={limit}
              onPageChange={(page) => {
                setPage(page);
                getCarteiras(activeTab, currentFilters, page, limit);
              }}
            />
          </div>
        )}

        {activeTab === "vendedores" && (
          <div className="border-t border-gray-300 p-2 flex flex-col">
            <button
              className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:bg-green-600 transition-all duration-300 transform hover:scale-105 mb-4 ml-auto"
              onClick={() => setIsDrawerOpen(true)}
            >
              Gerenciar Colaboradores
            </button>

            <div className="grid grid-cols-1 gap-5">
              <div
                className={`grid ${
                  isSingleColumn ? "grid-cols-1" : "grid-cols-2"
                } 1500px:grid-cols-2 1100px:grid-cols-1`}
              >
                {carteiras.map((carteira) => (
                  <VendedorCarteira
                    key={carteira.codigoUso}
                    carteira={carteira}
                    imagens={imagens}
                    handleImageUpload={handleImageUpload}
                    setImagem={setImagem}
                    save={save}
                    handleInputChange={handleInputChange}
                    toggleSave={toggleSave}
                    handleSave={handleSave}
                    onTagChange={handleTagChange} // Pass the new function
                  />
                ))}
              </div>
              <div className="Resultados">
                {" "}
                {totalCount} Resultados encontrados{" "}
              </div>
              <Pagination
                className="pagination-bar"
                currentPage={page}
                totalCount={totalCount}
                pageSize={limit}
                onPageChange={(page) => {
                  setPage(page);
                  getCarteiras(activeTab, currentFilters, page, limit);
                }}
              />
            </div>
          </div>
        )}
      </div>
      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => {
          setIsDrawerOpen(false);
          getCarteiras("vendedores", currentFilters, page, limit);
        }}
      >
        <VendedoresContent />
      </Drawer>
    </>
  );
};

Painel.propTypes = {
  carteiras: PropTypes.array,
  setCarteiras: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isSingleColumn: PropTypes.bool.isRequired,
  getCarteiras: PropTypes.func.isRequired,
  filtragem: PropTypes.bool.isRequired,
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  pagination: PropTypes.shape({
    page: PropTypes.number,
    limit: PropTypes.number,
    setPage: PropTypes.func,
    setLimit: PropTypes.func,
    totalCount: PropTypes.number,
  }),
  currentFilters: PropTypes.object,
};

export default Painel;
